import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/productos/getProductos.php';

export default function getProductos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}